// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  CoachListCoachFragmentDoc,
  CoachListCategoryFragmentDoc,
  CoachListLelandPlusContributorCoachBatchResponseFragmentDoc,
  CoachListOfferingPackageFragmentDoc,
  CoachListSkuFragmentDoc,
} from './CoachList.generated';
import {
  SearchFiltersCategoryFragmentDoc,
  SearchFiltersSkuFragmentDoc,
} from './SearchFilters.generated';
export type CoachesSectionWithFilterCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  isSuperCoach?: boolean | null;
  totalCoachingMinutes: number;
  isSaved?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    id: string;
    headline?: string | null;
    testScore?: number | null;
    qualifications?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      slug: string;
      name: string;
      goal: Types.GoalName;
    };
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  outcomes?: Array<
    | {
        __typename?: 'CareerOutcomeSummary';
        companies: Array<{
          __typename?: 'Company';
          id?: string | null;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'SchoolOutcomeSummary';
        schools: Array<{
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        }>;
      }
    | {
        __typename?: 'TestOutcomeSummary';
        scoreRange?: string | null;
        category: { __typename?: 'Category'; id: string };
      }
  > | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  schoolAdmissionInfoList?: Array<{
    __typename?: 'SchoolAdmissionInfo';
    status?: Types.SchoolAdmissionStatus | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  companiesAdmitted?: Array<{
    __typename?: 'Company';
    id?: string | null;
    name: string;
    domain?: string | null;
    logoLink?: string | null;
  }> | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      timeInMinute: number;
      start?: number | null;
      end?: number | null;
    }> | null;
  } | null;
};

export type CoachesSectionWithFilterCategoryFragment = {
  __typename?: 'Category';
  id: string;
  slug: string;
  goal: Types.GoalName;
  name: string;
  shouldShowSubCategories?: boolean | null;
  subCategoryTitle?: string | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
    description?: string | null;
    libraryPath?: string | null;
  }> | null;
  subCategoryList?: Array<{
    __typename?: 'SubCategory';
    id: string;
    slug: string;
    v2Urn: string;
    name: string;
  }> | null;
};

export type CoachesSectionWithFilterLelandPlusContributorCoachBatchResponseFragment =
  {
    __typename?: 'CoachBatchResponse';
    total: number;
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
    }>;
  };

export type CoachesSectionWithFilterOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  slug?: string | null;
  name: string;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
};

export type CoachesSectionWithFilterSkuFragment = {
  __typename?: 'Sku';
  id: string;
  tier: Types.SkuTier;
  unitPrice: number;
};

export const CoachesSectionWithFilterCoachFragmentDoc = gql`
  fragment CoachesSectionWithFilter_Coach on Coach {
    ...CoachList_Coach
  }
  ${CoachListCoachFragmentDoc}
`;
export const CoachesSectionWithFilterCategoryFragmentDoc = gql`
  fragment CoachesSectionWithFilter_Category on Category {
    id
    slug
    goal
    ...SearchFilters_Category
    ...CoachList_Category
  }
  ${SearchFiltersCategoryFragmentDoc}
  ${CoachListCategoryFragmentDoc}
`;
export const CoachesSectionWithFilterLelandPlusContributorCoachBatchResponseFragmentDoc = gql`
  fragment CoachesSectionWithFilterLelandPlusContributor_CoachBatchResponse on CoachBatchResponse {
    ...CoachListLelandPlusContributor_CoachBatchResponse
  }
  ${CoachListLelandPlusContributorCoachBatchResponseFragmentDoc}
`;
export const CoachesSectionWithFilterOfferingPackageFragmentDoc = gql`
  fragment CoachesSectionWithFilter_OfferingPackage on OfferingPackage {
    ...CoachList_OfferingPackage
  }
  ${CoachListOfferingPackageFragmentDoc}
`;
export const CoachesSectionWithFilterSkuFragmentDoc = gql`
  fragment CoachesSectionWithFilter_Sku on Sku {
    ...SearchFilters_Sku
    ...CoachList_Sku
  }
  ${SearchFiltersSkuFragmentDoc}
  ${CoachListSkuFragmentDoc}
`;
